import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_000.jpg';

page.gallery = [
  {
    id: 'u1',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta1/1_hello.jpg',
        audio: {
          audioSrc: 'audio/karta1/1_hello.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta1/2_bye_bye.jpg',
        audio: {
          audioSrc: 'audio/karta1/2_bye_bye.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta1/3_Tom.jpg',
        audio: {
          audioSrc: 'audio/karta1/3_Tom.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta1/4_Lisa.jpg',
        audio: {
          audioSrc: 'audio/karta1/4_Lisa.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u2',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta2/8_blue.jpg',
        audio: {
          audioSrc: 'audio/karta2/8_blue.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta2/9_red.jpg',
        audio: {
          audioSrc: 'audio/karta2/9_red.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta2/10_yellow.jpg',
        audio: {
          audioSrc: 'audio/karta2/10_yellow.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta2/11_green.jpg',
        audio: {
          audioSrc: 'audio/karta2/11_green.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u3',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta3/15_happy.jpg',
        audio: {
          audioSrc: 'audio/karta3/15_happy.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta3/16_sad.jpg',
        audio: {
          audioSrc: 'audio/karta3/16_sad.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta3/18_angry.jpg',
        audio: {
          audioSrc: 'audio/karta3/18_angry.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta3/17_calm.jpg',
        audio: {
          audioSrc: 'audio/karta3/17_calm.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u4',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta4/22_mummy.jpg',
        audio: {
          audioSrc: 'audio/karta4/22_mummy.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta4/23_daddy.jpg',
        audio: {
          audioSrc: 'audio/karta4/23_daddy.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta4/24_sister.jpg',
        audio: {
          audioSrc: 'audio/karta4/24_sister.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta4/25_brother.jpg',
        audio: {
          audioSrc: 'audio/karta4/25_brother.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u5',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta5/29_car.jpg',
        audio: {
          audioSrc: 'audio/karta5/29_car.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta5/30_doll.jpg',
        audio: {
          audioSrc: 'audio/karta5/30_doll.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta5/31_ball.jpg',
        audio: {
          audioSrc: 'audio/karta5/31_ball.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta5/32_robot.jpg',
        audio: {
          audioSrc: 'audio/karta5/32_robot.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u6',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta6/36_sing.jpg',
        audio: {
          audioSrc: 'audio/karta6/36_sing.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta6/41_paint.jpg',
        audio: {
          audioSrc: 'audio/karta6/41_paint.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta6/38_clap.jpg',
        audio: {
          audioSrc: 'audio/karta6/38_clap.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta6/39_dance.jpg',
        audio: {
          audioSrc: 'audio/karta6/39_dance.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u7',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta7/43_banana.jpg',
        audio: {
          audioSrc: 'audio/karta7/43_banana.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta7/44_pear.jpg',
        audio: {
          audioSrc: 'audio/karta7/44_pear.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta7/45_cherry.jpg',
        audio: {
          audioSrc: 'audio/karta7/45_cherry.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta7/46_lemon.jpg',
        audio: {
          audioSrc: 'audio/karta7/46_lemon.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u8',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta8/50_dog.jpg',
        audio: {
          audioSrc: 'audio/karta8/50_dog.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta8/51_cat.jpg',
        audio: {
          audioSrc: 'audio/karta8/51_cat.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta8/52_mouse.jpg',
        audio: {
          audioSrc: 'audio/karta8/52_mouse.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta8/53_fish.jpg',
        audio: {
          audioSrc: 'audio/karta8/53_fish.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u9',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta9/57_legs.jpg',
        audio: {
          audioSrc: 'audio/karta9/57_legs.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta9/58_hands.jpg',
        audio: {
          audioSrc: 'audio/karta9/58_hands.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta9/59_head.jpg',
        audio: {
          audioSrc: 'audio/karta9/59_head.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta9/60_tummy.jpg',
        audio: {
          audioSrc: 'audio/karta9/60_tummy.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u10',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta10/64_hat.jpg',
        audio: {
          audioSrc: 'audio/karta10/64_hat.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta10/65_T-shirt.jpg',
        audio: {
          audioSrc: 'audio/karta10/65_T-shirt.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta10/66_dress.jpg',
        audio: {
          audioSrc: 'audio/karta10/66_dress.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta10/67_jumper.jpg',
        audio: {
          audioSrc: 'audio/karta10/67_jumper.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },

  {
    id: 'u11',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta11/71_Christmas tree.jpg',
        audio: {
          audioSrc: 'audio/karta11/71_Christmas tree.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta11/72_baubles.jpg',
        audio: {
          audioSrc: 'audio/karta11/72_baubles.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta11/73_bells.jpg',
        audio: {
          audioSrc: 'audio/karta11/73_bells.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta11/74_stars.jpg',
        audio: {
          audioSrc: 'audio/karta11/74_stars.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u12',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta12/75_costume.jpg',
        audio: {
          audioSrc: 'audio/karta12/75_costume.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta12/76_dino.jpg',
        audio: {
          audioSrc: 'audio/karta12/76_dino.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta12/77_clown.jpg',
        audio: {
          audioSrc: 'audio/karta12/77_clown.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta12/78_pirate.jpg',
        audio: {
          audioSrc: 'audio/karta12/78_pirate.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u13',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta13/79_pizza.jpg',
        audio: {
          audioSrc: 'audio/karta13/79_pizza.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta13/80_cheese.jpg',
        audio: {
          audioSrc: 'audio/karta13/80_cheese.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta13/81_tomato sauce.jpg',
        audio: {
          audioSrc: 'audio/karta13/81_tomato sauce.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta13/82_ham.jpg',
        audio: {
          audioSrc: 'audio/karta13/82_ham.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 'u14',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/karta14/83_Easter_eggs.jpg',
        audio: {
          audioSrc: 'audio/karta14/83_Easter_eggs.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta14/84_decorate.jpg',
        audio: {
          audioSrc: 'audio/karta14/84_decorate.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta14/85_chocolate.jpg',
        audio: {
          audioSrc: 'audio/karta14/85_chocolate.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/karta14/86_Easter_bunny.jpg',
        audio: {
          audioSrc: 'audio/karta14/86_Easter_bunny.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
];
page.games = [
  {
    id: 'page000_game0',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game1',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game2',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game3',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game4',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game5',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game6',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game7',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game8',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game9',
    pos: { x: LEFT, y: 0 },
  },
  {
    id: 'page000_game10',
    pos: { x: LEFT, y: 0 },
  },

  { id: 'page765_game0', pos: { x: LEFT, y: 0 } },
  { id: 'page765_game1', pos: { x: LEFT, y: 0 } },
  { id: 'page765_game2', pos: { x: LEFT, y: 0 } },
  { id: 'page765_game3', pos: { x: LEFT, y: 0 } },

  { id: 'page766_game0', pos: { x: LEFT, y: 0 } },
  { id: 'page766_game1', pos: { x: LEFT, y: 0 } },
  { id: 'page766_game2', pos: { x: LEFT, y: 0 } },
  { id: 'page766_game3', pos: { x: LEFT, y: 0 } },
  { id: 'page766_game4', pos: { x: LEFT, y: 0 } },
];

export default page;
